import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useUserGroupService} from "../../services/user-group-service";
import AddEditUserGroupModal from "./add-edit-user-group-modal";
import UserAvatar from "../../components/user-avatar";

export default function UserGroupsList () {
  let userGroupService = useUserGroupService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();

  useEffect(()=>{
    userGroupService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    const newItem = {...item, users_count: !item.users ? 0 : item.users.length };
    setRows(HelperService.addOrReplaceItemInList(rows,newItem));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      userGroupService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Názov skupiny',
    selector: row => row.title,
    sortable: true,
  },{
    name: 'Počet používatelov',
    selector: row => row.users_count,
    sortable: true,
  },{
    name: 'Používatelia',
    selector: row => <div className="d-flex align-content-center align-items-center gap-1 py-1">
      {row.users.map(user=>{
        return <UserAvatar key={`${row.id}-${user.id}`} user={user} />;
      })}
    </div>,
    filterSelector: row => row.users.map(user=>{
      return user.name;
    }).join(','),
    sortable: false,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    allowOverflow: true,
    button: true,
  }];

  return (
    <>
      <AddEditUserGroupModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Skupiny používatelov</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

UserGroupsList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

UserGroupsList.getSEO = function getSEO() {
  return {
    title: "Skupiny používatelov",
  }
}
